import React, { useEffect, useState } from "react";
import { Dropdown, Menu, notification } from "antd";
import { MenuProps } from "antd/lib";
import { useDispatch } from "react-redux";
import { putData } from "../../../../../actions/developer";

interface SearchStatusProps {
    task: {
        _id: string;
        columnId?: string;
    };
    columnData: any[];
}
interface columnProps {
    _id: string;
    name: string;
    order: number;
}

const SearchStatus: React.FC<SearchStatusProps> = ({
    task,
    columnData
}) => {
    const [filteredItems] = useState<columnProps[]>(columnData);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (task?.columnId) {
            const column = columnData.find((column) => column._id === task.columnId);
            setSelected(column?.name);
        }
    }, [task]);

    const updateTaskStatus = async (key) => {
        const resData = await dispatch(putData(`/tasks/${task._id}`, { columnId: key }));
        if (!resData) {
            notification.error({ message: 'Error', description: 'Failed to update task status' });
        }
    }

    const menuItems: MenuProps = {
        items: filteredItems.map((item, index) => ({
            key: item._id,
            label: item.name
        })),
        onClick: ({ key }) => {
            setSelected(filteredItems.find((column) => column._id === key).name);
            updateTaskStatus(key)
        }
    }

    return (
        <Dropdown
            menu={menuItems}
            trigger={['click']}
            open={dropdownOpen}
            onOpenChange={(open) => setDropdownOpen(open)}
            placement="bottomLeft"
        >
            <div>
                {selected ?? 'To Do'}
            </div>
        </Dropdown>
    );
};

export default SearchStatus;
